import { Service, ServiceInitializer } from '@estee/elc-service';
import { IAppConfig, root } from '@estee/elc-universal-utils';
import { mapConfigToProps } from './DrupalConfigStore';
import { defaultAppRoutes } from '../routes/index';
import { getServiceBusController, diContainer, serviceNames } from './diContainer';
import { ELC_RAMP } from '@estee/elc-service-view-names';

const { name, version } = __serviceInfo__;
const SIGN_IN_SERVICE = 'elc-service-sign-in';
const TRANSLATIONS_SERVICE = 'elc-service-translations';
const CONFIG_MANAGER_SERVICE = 'elc-service-config-manager';

const ELC_RAMP_SERVICE_VIEW_NAME = ELC_RAMP;

interface IServiceRegistryVersions {
    [key: string]: string;
}

export class RampApp extends Service {
    // private disabledServices: string[] = [];
    constructor(serviceInitializer: ServiceInitializer = getServiceBusController) {
        super(name, version, serviceInitializer);
        this.initializeServiceVersions();
    }
    public async start(appConfig: IAppConfig = {}) {
        if (this.isStarted) {
            return;
        }
        appConfig.routes = Object.assign(appConfig.routes || {}, defaultAppRoutes);
        const props = mapConfigToProps(appConfig);
        // Use @ as a service and version separator if there is at least one script
        // in page that uses that convention
        const useAtSignSeparator = Array.from(document.querySelectorAll('script'))
            .map((s) => s.src)
            .filter((src) => src.indexOf(props.cdnPath) !== -1)
            .some((src) => src.split('@').length > 1);
        const versionSeparator = useAtSignSeparator ? '@' : '/';

        const replaceFunction = (originalSrc: string) => {
            const sourceInfo = originalSrc.slice(originalSrc.indexOf('elc-'));
            const [serviceName, chunkName] = sourceInfo.split('/');
            const serviceVersion = props.services[serviceName];

            return `${props.cdnPath}/${serviceName}${versionSeparator}${serviceVersion}/${chunkName}`;
        };
        root.replaceSrc = root.replaceSrc || replaceFunction;
        void super.start(props);
        this.setupHttpTransport(props.defaultDomain, props.businessUnitId, props.clientId);
        this.registerViews();
        diContainer.get(serviceNames.serviceBusController);
        await this.bootstrap(props);
    }
    private setupHttpTransport = (
        defaultDomain: string,
        businessUnitId: string,
        clientId: string
    ) => {
        root.HttpTransport.setBaseUrl(defaultDomain);
        root.HttpTransport.addGlobalHeaders({
            'Business-Unit': businessUnitId,
            ClientId: clientId || 'stardust-fe-client'
        });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private bootstrap = async (props: any) => {
        const serviceSignIn = root.ServiceRegistry[SIGN_IN_SERVICE];
        const serviceTranslate = root.ServiceRegistry[TRANSLATIONS_SERVICE];
        const serviceConfig = root.ServiceRegistry[CONFIG_MANAGER_SERVICE];

        try {
            await serviceSignIn.start(props);
            await serviceConfig.start(props);
            await serviceTranslate.start(props);

            if (document.body) {
                await this.initComponentRenderer();
            } else {
                // means our bootstrap ran first, wait until document.body exists
                document.addEventListener('DOMContentLoaded', async () => {
                    await this.initComponentRenderer();
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    private initComponentRenderer = async () => {
        if (root.ComponentRenderer) {
            await root.ComponentRenderer.init();
        }
    };

    private registerViews() {
        this.registerView(ELC_RAMP_SERVICE_VIEW_NAME, () => import('../exported/Ramp'));
    }

    private initializeServiceVersions() {
        root.getServiceVersions = () => {
            const serviceRegistryVersions: IServiceRegistryVersions = {};
            Object.keys(root.ServiceRegistry).forEach((key) => {
                serviceRegistryVersions[key] = root.ServiceRegistry[key].version;
            });
        };
    }
}
